<script setup lang="ts">
  import { onMounted, ref } from 'vue';
  import { CircleX } from 'lucide-vue-next';

  const dialogRef = ref<HTMLDialogElement>();

  const { closedby = 'any', closeCallback } = defineProps<{
    closedby?: 'any' | 'closerequest' | 'none';
    closeCallback?: () => void;
  }>();

  const emit = defineEmits(['open', 'close']);

  function showModal() {
    if (dialogRef.value) {
      dialogRef.value.showModal();
      emit('open');
    }
  }

  function close() {
    if (dialogRef.value) {
      dialogRef.value.close();
    }
  }

  onMounted(() => {
    if (dialogRef.value) {
      dialogRef.value.addEventListener('close', () => emit('close'));
    }
  });

  function closeButton() {
    if (closeCallback) closeCallback();
    else close();
  }

  defineExpose({ showModal, close });
</script>

<template>
  <dialog
    ref="dialogRef"
    class="p-8 border-none rounded-xl"
    :closedby
  >
    <button
      type="button"
      aria-label="close"
      class="rounded-full hover:bg-grey-lightest absolute top-2 right-2"
      @click="closeButton"
    >
      <CircleX class="text-grey-middle" />
    </button>

    <slot></slot>
  </dialog>
</template>

<style lang="postcss">
  dialog::backdrop {
    background-color: rgba(0, 0, 0, 0.5);
    backdrop-filter: blur(4px);
  }
</style>
